module.exports = __webpack_public_path__ + "static/media/Tupe4.af1849d9.webp";